<div class="store-detail-container">
  <div class="store-detail-content">
    <!-- Header Section -->
    <div class="store-header">
      <div class="store-info">
        <div class="store-title-row">
          <div class="store-title-container">
            <h1 class="store-name">{{ storeData.name }}</h1>
          </div>
          <button class="share-btn" (click)="onShare()" type="button" aria-label="Open store detail page"
                  [disabled]="!storeUuid" [style.opacity]="storeUuid ? '1' : '0.3'">
            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.5 6L14.5 2M14.5 2H10.5M14.5 2L9.16667 7.33333M7.16667 3.33333H5.7C4.5799 3.33333 4.01984 3.33333 3.59202 3.55132C3.21569 3.74307 2.90973 4.04903 2.71799 4.42535C2.5 4.85318 2.5 5.41323 2.5 6.53333V10.8C2.5 11.9201 2.5 12.4802 2.71799 12.908C2.90973 13.2843 3.21569 13.5903 3.59202 13.782C4.01984 14 4.5799 14 5.7 14H9.96667C11.0868 14 11.6468 14 12.0746 13.782C12.451 13.5903 12.7569 13.2843 12.9487 12.908C13.1667 12.4802 13.1667 11.9201 13.1667 10.8V9.33333" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <p class="store-address">{{ storeData.address }}</p>
      </div>
      <button class="close-btn" (click)="close()" type="button" aria-label="Close store report">
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18.5 6.5L6.5 18.5M6.5 6.5L18.5 18.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Company / Banner Ranking Section -->
    <div class="ranking-section">
      <div class="section-header">
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.49967 11.1667V5.30002C2.49967 4.55328 2.49967 4.17992 2.645 3.8947C2.77283 3.64382 2.9768 3.43984 3.22769 3.31201C3.5129 3.16669 3.88627 3.16669 4.63301 3.16669H12.3663C13.1131 3.16669 13.4864 3.16669 13.7717 3.31201C14.0225 3.43984 14.2265 3.64382 14.3543 3.8947C14.4997 4.17992 14.4997 4.55328 14.4997 5.30002V11.1667H10.9415C10.7784 11.1667 10.6969 11.1667 10.6202 11.1851C10.5522 11.2014 10.4871 11.2284 10.4275 11.2649C10.3602 11.3062 10.3026 11.3638 10.1873 11.4791L10.1454 11.5209C10.0301 11.6362 9.97248 11.6939 9.9052 11.7351C9.84555 11.7717 9.78052 11.7986 9.7125 11.8149C9.63577 11.8334 9.55424 11.8334 9.39118 11.8334H7.60817C7.44511 11.8334 7.36358 11.8334 7.28685 11.8149C7.21883 11.7986 7.1538 11.7717 7.09415 11.7351C7.02687 11.6939 6.96922 11.6362 6.85392 11.5209L6.81209 11.4791C6.69679 11.3638 6.63914 11.3062 6.57186 11.2649C6.51222 11.2284 6.44719 11.2014 6.37916 11.1851C6.30244 11.1667 6.22091 11.1667 6.05785 11.1667H2.49967ZM2.49967 11.1667C2.13148 11.1667 1.83301 11.4652 1.83301 11.8334V12.0556C1.83301 12.4689 1.83301 12.6756 1.87844 12.8451C2.00173 13.3052 2.36113 13.6646 2.82125 13.7879C2.9908 13.8334 3.19746 13.8334 3.61079 13.8334H13.3886C13.8019 13.8334 14.0085 13.8334 14.1781 13.7879C14.6382 13.6646 14.9976 13.3052 15.1209 12.8451C15.1663 12.6756 15.1663 12.4689 15.1663 12.0556C15.1663 11.8489 15.1663 11.7456 15.1436 11.6608C15.082 11.4307 14.9023 11.251 14.6722 11.1894C14.5874 11.1667 14.4841 11.1667 14.2775 11.1667H13.833" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <h2 class="section-title">Company Ranking <span class="section-subtitle" *ngIf="storeData.bannerLabel">({{ storeData.bannerLabel }})</span></h2>
      </div>
      <div class="metrics-container">
        <div class="metrics-grid">
          <div *ngFor="let metric of storeData.companyRankings" class="metric-card"
               [style.border-left-color]="metric.borderColor">
            <div class="metric-inner">
              <div class="metric-header">
                <h3 class="metric-heading">{{ metric.heading }}</h3>
                <div class="metric-badge"
                     [style.background-color]="metric.badge.backgroundColor"
                     [style.color]="metric.badge.color">
                  <div class="badge-dot" [style.background-color]="metric.badge.color"></div>
                  <span class="badge-text">{{ metric.badge.label }}</span>
                </div>
              </div>

              <div class="metric-body">
                <div class="metric-numbers">
                  <span class="metric-rank">{{ (!metric.rank || metric.rank == 0 || !metric.hasData) ? 'N/A' : metric.rank  }}</span>
                  <span class="metric-total" *ngIf="metric.total || metric.total != 0 || metric.hasData">of {{  metric.total   }}</span>
                </div>
                <!-- <div class="metric-no-data" *ngIf="!metric.hasData">
                  <div class="no-data-line"></div>
                  <span class="no-data-text">{{ metric.customText }}</span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Industry Ranking Section -->
    <div class="ranking-section">
      <div class="section-header">
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.49967 7.93612H3.56634C3.19297 7.93612 3.00629 7.93612 2.86368 8.00878C2.73824 8.07269 2.63625 8.17468 2.57234 8.30012C2.49967 8.44273 2.49967 8.62942 2.49967 9.00278V14.6028M11.4997 7.93612H13.433C13.8064 7.93612 13.9931 7.93612 14.1357 8.00878C14.2611 8.07269 14.3631 8.17468 14.427 8.30012C14.4997 8.44273 14.4997 8.62942 14.4997 9.00278V14.6028M11.4997 14.6028V4.73612C11.4997 3.98938 11.4997 3.61601 11.3544 3.3308C11.2265 3.07991 11.0225 2.87594 10.7717 2.74811C10.4864 2.60278 10.1131 2.60278 9.36634 2.60278H7.63301C6.88627 2.60278 6.5129 2.60278 6.22769 2.74811C5.9768 2.87594 5.77283 3.07991 5.645 3.3308C5.49967 3.61601 5.49967 3.98938 5.49967 4.73612V14.6028M15.1663 14.6028H1.83301M7.83301 5.26945H9.16634M7.83301 7.93612H9.16634M7.83301 10.6028H9.16634" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <h2 class="section-title">Industry Ranking</h2>
      </div>
      <div class="metrics-container">
        <div class="metrics-grid">
          <div *ngFor="let metric of storeData.industryRankings" class="metric-card"
               [style.border-left-color]="metric.borderColor">
            <div class="metric-inner">
              <div class="metric-header">
                <h3 class="metric-heading">{{ metric.heading }}</h3>
                <div class="metric-badge"
                     [style.background-color]="metric.badge.backgroundColor"
                     [style.color]="metric.badge.color">
                  <div class="badge-dot" [style.background-color]="metric.badge.color"></div>
                  <span class="badge-text">{{ metric.badge.label }}</span>
                </div>
              </div>

              <div class="metric-body">
                <div class="metric-numbers" >
                   <span class="metric-rank">{{ (!metric.rank || metric.rank == 0 || !metric.hasData) ? 'N/A' : metric.rank  }}</span>
                  <span class="metric-total" *ngIf="metric.total || metric.total != 0 || metric.hasData">of {{  metric.total   }}</span>
               </div>
                <!-- <div class="metric-no-data" *ngIf="!metric.hasData">
                  <div class="no-data-line"></div>
                  <span class="no-data-text">{{ metric.customText }}</span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
